import {
  portalFooterLinks,
  portalFooterLogoSrc,
  portalFooterSocials,
} from "@/data/portal_homepage";
import { buildPortalBonusCampaignPageView } from "@/data/portal_bonus_campaign_mappers";
import {
  fetchPortalBonusCampaignsMock,
  portalBonusCampaignPageMeta,
  portalBonusCampaignsApiMock,
} from "@/data/portal_bonus_campaigns_mock";

export const BONUS_CAMPAIGN_SLUG_UHRD = "uhrd";
export const BONUS_CAMPAIGN_SLUG_GOALS = "goals";
export const BONUS_CAMPAIGN_SLUG_AWANS = "awans";

const SLUG_TO_PROGRAM_KEY = {
  [BONUS_CAMPAIGN_SLUG_UHRD]: "uhrd",
  [BONUS_CAMPAIGN_SLUG_AWANS]: "awans",
  [BONUS_CAMPAIGN_SLUG_GOALS]: "goals",
};

function buildPageForSlug(slug) {
  const programKey = SLUG_TO_PROGRAM_KEY[slug];
  return buildPortalBonusCampaignPageView(
    programKey,
    portalBonusCampaignPageMeta[programKey]
  );
}

export const portalBonusCampaignDataset = {
  [BONUS_CAMPAIGN_SLUG_UHRD]: buildPageForSlug(BONUS_CAMPAIGN_SLUG_UHRD),
  [BONUS_CAMPAIGN_SLUG_AWANS]: buildPageForSlug(BONUS_CAMPAIGN_SLUG_AWANS),
  [BONUS_CAMPAIGN_SLUG_GOALS]: buildPageForSlug(BONUS_CAMPAIGN_SLUG_GOALS),
};

export function getPortalBonusCampaignPageData(slug) {
  return portalBonusCampaignDataset[slug] ?? null;
}

/** @param {string} slug */
export async function loadPortalBonusCampaignPageData(slug) {
  const api = await fetchPortalBonusCampaignsMock();
  const programKey = SLUG_TO_PROGRAM_KEY[slug];
  return buildPortalBonusCampaignPageView(
    programKey,
    portalBonusCampaignPageMeta[programKey],
    api
  );
}

export { portalBonusCampaignsApiMock, fetchPortalBonusCampaignsMock };

export const portalBonusCampaignFooter = {
  footerLinks: portalFooterLinks,
  footerLogoSrc: portalFooterLogoSrc,
  footerSocials: portalFooterSocials,
};
